import { EntityWithDocumentFullResponse } from '@/modules/entity/types/EntityItemResponse.ts';
import {
  renderEntityContactDetails,
  renderEntityDetailsSection,
  renderEntityDocuments,
  renderEntityTaxResidence,
} from '@/modules/entity/utils/entity-info/entity-info.tsx';

export const RenderIndividualEntityDetails = ({
  individual_entity_details,
  document_files,
  ...entity_details
}: Partial<EntityWithDocumentFullResponse>) => {
  const {
    title,
    first_name,
    middle_name,
    last_name,
    date_of_birth,
    country,
    gender,
    state,
    suburb,
    postcode,
    is_us_person,
    non_us_person_certification,
    tax_residence,
    jointly,
    locality,
    crs_status,
    is_managed_by_another_institution,
    sponsoring_entity_name,
    account_holders_gin,
  } = individual_entity_details || {};

  const { bank_name, bank_account_bsb, bank_account_number, bank_account_name } =
    entity_details || {};

  return (
    <>
      {renderEntityContactDetails(entity_details)}
      {renderEntityDetailsSection({
        name: 'Individual details',
        items: [
          { label: 'Gender', value: gender },
          { label: 'Title', value: title },
          { label: 'First Name', value: first_name },
          { label: 'Middle Name', value: middle_name },
          { label: 'Last name', value: last_name },
          { label: 'Date of birth', value: date_of_birth },
          { label: 'Country', value: country },
          { label: 'State', value: state },
          { label: 'Suburb', value: suburb },
          { label: 'Locality', value: locality },
          { label: 'Postcode', value: postcode },
        ],
      })}
      {jointly &&
        renderEntityDetailsSection({
          name: 'Individual / Jointly details',
          items: [
            { label: 'Gender', value: jointly.gender },
            { label: 'Title', value: jointly.title },
            { label: 'First Name', value: jointly.first_name },
            { label: 'Middle Name', value: jointly.middle_name },
            { label: 'Last name', value: jointly.last_name },
            { label: 'Date of birth', value: jointly.date_of_birth },
            { label: 'Country', value: jointly.country },
            { label: 'State', value: jointly.state },
            { label: 'Suburb', value: jointly.suburb },
            { label: 'Postcode', value: jointly.postcode },
          ],
        })}
      {renderEntityTaxResidence(tax_residence)}
      {renderEntityDetailsSection({
        items: [
          { label: 'GIIN', value: account_holders_gin },
          { label: 'Sponsoring entity name', value: sponsoring_entity_name },
          {
            label:
              'Is the Account Holder a specified U.S. person? A U.S. person includes a U.S. citizen or resident alien of the U.S. even if residing outside the U.S.',
            value: is_us_person,
          },
          { label: 'Non U.S Person Certification', value: non_us_person_certification },

          {
            label: 'Is the entity an Investment Entity managed by another Financial Institution?',
            value: is_managed_by_another_institution,
          },
          { label: 'CRS status', value: crs_status },
        ],
      })}
      {renderEntityDetailsSection({
        name: 'Payment instructions',
        items: [
          { label: 'Bank name', value: bank_name },
          { label: 'BSB', value: bank_account_bsb },
          { label: 'Account number', value: bank_account_number },
          { label: 'Account name', value: bank_account_name },
        ],
      })}
      {renderEntityDocuments(document_files || [])}
    </>
  );
};
